import React, {useEffect, useState} from "react";
import queryString from 'query-string';
import history from "../../history";
import {Card,Row,Col,message,Spin,Form,Input,Select,Button,Tooltip as TooltipAnd} from 'antd';
import getYibfEslesmemeSebebiList from "../../services/yibfEslesmemeSebebiList";
import getTapuMahalleList from "../../services/tapuMahalleList";
import getAdaParselList from "../../services/adaParselList";
import getEbIskanMuellifList from "../../services/ebIskanMuellifList";
import getEbYibfIsinDurumuList from "../../services/ebYibfIsinDurumuList";
import setEslemeyenYibf from "../../services/eslesmeyenYibfGuncelle";
import * as util from '../Helpers/Util';

const parsed = queryString.parse(history.location.search);
const { Option } = Select;

const formLayout = {
    labelCol : {
        span : 8
    },
    wrapperCol : {
        span : 16
    }
};

const formItemStyle = {
    marginLeft : 10
}

const YibfEslesmemeSebebiForm = () => {

    const KodEbYibfEslesmemeSebebi = {
        Mahalle     : 1,
        AdaParsel   : 2,
        YapiDenetim : 3,
        IsDurum     : 4
    };
    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();

    const [yibfEslesmemeSebebi, setYibfEslesmemeSebebi] = useState([]);
    const [eslesmeyenYibf, setEslesmeyenYibf] = useState([]);
    const [eslesmemeSebebi, setEslesmemeSebebi] = useState([]);
    const [tapuMahalle, setTapuMahalle] = useState([]);
    const [adaParsel, setAdaParsel] = useState([]);
    const [ebIskanMuellif, setEbIskanMuellif] = useState([]);
    const [ebYibfIsinDurumu, setEbYibfIsinDurumu] = useState([]);

    const yibfNo = parsed.yibfNo.split(',').map(item => {
        return parseInt(item)
    });



    const loadForm = async () => {
        await getYibfEslesmemeSebebiList(yibfNo).then(resp => {
            setYibfEslesmemeSebebi(resp.data.result);
            if (resp.data.result) {
                const yibfDetail = resp.data.result[0].eslesmeyenYibf;
                setEslesmeyenYibf(yibfDetail)
                setEslesmemeSebebi(resp.data.result[0].eslesmemeSebebi);
                if(util.isNullOrEmptyOrUndefined(yibfDetail.parselId) || resp.data.result[0].eslesmemeSebebiId == KodEbYibfEslesmemeSebebi.Mahalle){
                    getTapuMahalle(null, yibfDetail.ada, yibfDetail.parsel)
                }else{
                    getTapuMahalle(yibfDetail.parselId, null,null)
                }
               
                getAdaParselList().then(resp => setAdaParsel(resp.data.result));
                if(resp.data.result[0].eslesmemeSebebiId == KodEbYibfEslesmemeSebebi.Mahalle){
                    form.setFieldsValue({
                        TapuMahalleId: yibfDetail.tapuMahalleId,    
                        AdaParsel : yibfDetail.ada+'/'+yibfDetail.parsel,
                        IsinDurumuId : yibfDetail.yibfIsinDurumuId,
                        IskanMuellifId : yibfDetail.iskanMuellifYapiDntmId
                    }); 
                }else{
                    form.setFieldsValue({
                        TapuMahalleId: yibfDetail.tapuMahalleId,    
                        AdaParsel :  yibfDetail.parselId,
                        IsinDurumuId : yibfDetail.yibfIsinDurumuId,
                        IskanMuellifId : yibfDetail.iskanMuellifYapiDntmId
                    }); 
                }
              
            }
        });
        await getEbIskanMuellifList().then(resp => setEbIskanMuellif(resp.data.result));
        await getEbYibfIsinDurumuList().then(resp => setEbYibfIsinDurumu(resp.data.result));

       

        setSpining(false);
    }
    
    const getTapuMahalle = (parselId,ada,parsel) => {
        getTapuMahalleList(parselId, ada, parsel).then(resp => setTapuMahalle(resp.data.result));
        if(eslesmemeSebebi.objectid == KodEbYibfEslesmemeSebebi.Mahalle || eslesmemeSebebi.objectid == KodEbYibfEslesmemeSebebi.Parsel){
            form.setFieldsValue({
                TapuMahalleId : undefined
             });
        }
       
    }

    const getYibfFields = () => {
        return (
            <>
                <Col span={12}>
                    <Form.Item label='YİBF No' style={formItemStyle} labelAlign="left">
                        <Input value={yibfNo} disabled/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='İşin Durumu' style={formItemStyle} labelAlign="left">
                        <Input value={eslesmeyenYibf.isinDurumu} disabled/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Mahalle Köy' style={formItemStyle}  labelAlign="left">
                        <Input value={eslesmeyenYibf.mahalleKoy}disabled/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Ada' style={formItemStyle}  labelAlign="left">
                        <Input value={eslesmeyenYibf.ada} disabled/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Parsel' style={formItemStyle} labelAlign="left">
                        <Input value={eslesmeyenYibf.parsel} disabled/>
                    </Form.Item>
                </Col>
                <Col span={12} >
                    <Form.Item label='Eşleşmeme Sebebi' style={formItemStyle} labelAlign="left">
                        <Input value={eslesmemeSebebi.adi} disabled/>
                    </Form.Item>
                </Col>
                <Col span={12} >
                    <Form.Item label='Yapı Denetim Kuruluşu' style={formItemStyle} labelAlign="left">
                        <Input value={ eslesmeyenYibf.yapiDenetimKurulusu} disabled/>
                    </Form.Item>
                </Col>
            </>
        );
    };

    function disabledSetter(index){
    
        const findeIndex = yibfEslesmemeSebebi.findIndex(p=>p.eslesmemeSebebiId == index);
        if(findeIndex >= 0 ){
            return false;
        }else{
            return true;
        }
    }

    const getYibfEslestirmeField = () => {
        return (
            <>
                <Col span={12}>
                    <Form.Item label='Tapu Mahalle Adı[E]' name='TapuMahalleId' style={formItemStyle} labelAlign="left">
                    <Select
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        disabled={eslesmeyenYibf.tapuMahalleId != undefined}>
                            {tapuMahalle && tapuMahalle.map(bt => <Option  key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                    </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Ada/Parsel[E]' name={'AdaParsel'} style={formItemStyle} labelAlign="left">
                    {(eslesmemeSebebi.objectid == KodEbYibfEslesmemeSebebi.Mahalle) ? 
                            <Input disabled/>
                        : 
                        <Select
                            showSearch
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onChange = {(parselId) => getTapuMahalle(parselId,null,null)}
                            disabled={eslesmeyenYibf.parselId != undefined}>
                                {adaParsel && adaParsel.map(bt => <Option  key={bt.objectId} value={bt.objectId}>{bt.adaParsel}</Option>)}
                        </Select>    
                    }                   
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='İşin Durumu[E]' name='IsinDurumuId'   style={formItemStyle} labelAlign="left">
                    <Select
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        disabled={disabledSetter(KodEbYibfEslesmemeSebebi.IsDurum)}>
                            {ebYibfIsinDurumu && ebYibfIsinDurumu.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                    </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Yapı Denetim[E]'  name='IskanMuellifId' style={formItemStyle} labelAlign="left">
                    <Select
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        disabled={disabledSetter(KodEbYibfEslesmemeSebebi.YapiDenetim)}>
                            {ebIskanMuellif && ebIskanMuellif.map(bt => <Option key={bt.ObjectId}  value={bt.ObjectId}>{bt.AdiUnvani}</Option>)}
                    </Select>
                    </Form.Item>                    
                </Col>               

            </>
        );
    };

    const success = (text) => {
        message.success(text);
      };
      const error = (text) => {
        message.error(text);
      };

    
    const onFinish = () =>{
        const tapuMahalleDetail = tapuMahalle.filter(k=>k.objectid == form.getFieldValue("TapuMahalleId") );
        
        var AdaParsel = form.getFieldValue("AdaParsel");
        var ParselId = (eslesmemeSebebi.objectid == KodEbYibfEslesmemeSebebi.Mahalle ? null : parseInt(AdaParsel))
        
        let filterModel= {};
        filterModel.YibfNo = parseInt(yibfNo[0]);
        filterModel.TapuMahalleId = parseInt(form.getFieldValue("TapuMahalleId"));
        filterModel.TapuMahalleAdi = (tapuMahalleDetail.length > 0 ) ? tapuMahalleDetail[0].adi : null;
        filterModel.IsinDurumuId = parseInt(form.getFieldValue("IsinDurumuId"));
        filterModel.IskanMuellifId = parseInt(form.getFieldValue("IskanMuellifId"));
        filterModel.ParselId = ParselId;
        filterModel.Ada = util.isNullOrEmptyOrUndefined(eslesmeyenYibf.ada) ? '' :  eslesmeyenYibf.ada.toString().trim() ;
        filterModel.Parsel = util.isNullOrEmptyOrUndefined(eslesmeyenYibf.parsel) ? '' :  eslesmeyenYibf.parsel.toString().trim() ;

        let data = JSON.stringify(filterModel);
        setEslemeyenYibf(data).then(res => { 
            if(res.data.success){
                success('İşlem başarı ile tamamlandı.');
                window.parent.location.reload()
            }else{
                error(res.data.message)
            }
        })
        .catch(ex => {
          setSpining(false);
        });
    }

    useEffect(() => {
        loadForm();
    }, []);

    return (
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
            <Card bodyStyle={{padding: "10"}}>
                YİBF Bilgileri
            </Card>
            <Form form={form}  {...formLayout}>
                <Row gutter={24}> {getYibfFields()}</Row>
            </Form>

            <Card bodyStyle={{padding: "10"}}>
                YİBF Bilgi Eşleştirme
            </Card>
            <Form form={form} {...formLayout}>
                <Row gutter={24}>{getYibfEslestirmeField()}</Row>
                <Row>
                    <Col span={24} style={{textAlign: 'right'}}>
                        <Button type="primary" onClick={onFinish}>
                            Güncelle
                        </Button>
                    </Col>  
                </Row>
            </Form>
        </Spin>
    );

}

export default YibfEslesmemeSebebiForm;
